import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import AboutLenses from "@/components/AboutLenses";
import ClinicCarousel from "@/components/ClinicCarousel";
import Testimonials from "@/components/Testimonials";
import RecentBlogPosts from "@/components/RecentBlogPosts";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import { Helmet } from "react-helmet";

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>Dra. Natália Piller - Dentística Estética e Harmonização Facial em São Paulo</title>
        <meta name="description" content="Consultório odontológico especializado em dentística estética e harmonização facial. Lentes de contato dental, clareamento, harmonização facial com Dra. Natália Piller em São Paulo. Atendimento humanizado e resultados naturais." />
        <meta name="keywords" content="dentista São Paulo, Dra. Natália Piller, lentes de contato dental, harmonização facial, clareamento dental, dentística estética, odontologia São Paulo" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Dra. Natália Piller - Dentística Estética e Harmonização Facial" />
        <meta property="og:description" content="Cada sorriso é único. O seu merece cuidado personalizado. Especialistas em estética dental e harmonização facial em São Paulo." />
        <meta property="og:url" content="https://dranataliaodonto.com.br" />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Dra. Natália Piller - Dentística Estética e Harmonização Facial" />
        <meta name="twitter:description" content="Cuidado personalizado para seu sorriso com resultados naturais em São Paulo." />
        
        {/* Canonical */}
        <link rel="canonical" href="https://dranataliaodonto.com.br" />
        
        {/* Structured Data - Local Business */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Dentist",
            "name": "NATALIA FERRAZ PILLER - ME",
            "legalName": "NATALIA FERRAZ PILLER - ME",
            "taxID": "42.802.042/0001-96",
            "image": "https://dranataliaodonto.com.br/og-image.jpg",
            "description": "Clínica odontológica especializada em Dentística Estética, Cirurgia Plástica Periodontal e Peri-implantar e Harmonização Facial. Unindo saúde gengival, estética dental e harmonização orofacial com atendimento humanizado e técnicas baseadas em evidências.",
            "url": "https://dranataliaodonto.com.br",
            "telephone": "+55-11-96314-0057",
            "priceRange": "$$$$",
            "foundingDate": "2021-07-21",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Rua Itapura, 239, Sala 401",
              "addressLocality": "Tatuapé, São Paulo",
              "addressRegion": "SP",
              "postalCode": "03310-000",
              "addressCountry": "BR"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": -23.5545,
              "longitude": -46.5756
            },
            "openingHoursSpecification": [
              {
                "@type": "OpeningHoursSpecification",
                "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
                "opens": "09:00",
                "closes": "18:00"
              }
            ],
            "aggregateRating": {
              "@type": "AggregateRating",
              "ratingValue": "5",
              "reviewCount": "150"
            }
          })}
        </script>
      </Helmet>
      
      <Header />
      <main>
        <Hero />
        <Services />
        <AboutLenses />
        <ClinicCarousel />
        <Testimonials />
        <RecentBlogPosts />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
